import { latLngToLocal } from "./utils";
import { useFrame, useUpdate } from "react-three-fiber";
import { Plane } from "drei";
import SETTINGS from "../../settings";

import { HeightMap } from "../../utils/topography";

import log from "loglevel";

const TerrainWireframe = (props) => {
  const size = props.heightMap.boundBox.size;
  const scale = SETTINGS.TERRAIN.SCALE;
  const mesh2 = useUpdate(({ geometry }) => {
    let pos = geometry.getAttribute("position");
    let pa = pos.array;

    for (let j = 0; j < props.heightMap.noOfVertices.y; j++) {
      for (let i = 0; i < props.heightMap.noOfVertices.x; i++) {
        pa[3 * (j * props.heightMap.noOfVertices.x + i) + 2] =
          (props.heightMap.altitudes[i][j] - props.heightMap.heightLimits.min) /
          1000;
      }
    }
    geometry.computeVertexNormals(true);
    pos.needsUpdate = true;
  });

  return (
    <>
      <Plane
        ref={mesh2}
        // receiveShadow
        // castShadow
        args={[
          size.x / scale,
          size.y / scale,
          props.heightMap.noOfVertices.x - 1,
          props.heightMap.noOfVertices.y - 1,
        ]}
        rotation={[-Math.PI / 2, 0, 0]}
      >
        <meshLambertMaterial
          attach="material"
          color={0x005500}
          wireframe={true}
        />
      </Plane>
    </>
  );
};

export default React.memo(TerrainWireframe);
